import { acquireAccessToken } from 'features/Authentication';
import { useEffect, useRef, useState } from 'react';
import { AuthenticationResult } from '@azure/msal-browser';

export interface IWopiProps {
  url: string;
  styles?: {
    iframe?: React.CSSProperties;
  };
}

function Wopi({ url, styles }: IWopiProps) {
  const [token, setToken] = useState<AuthenticationResult | null>(null);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (token && url) {
      formRef?.current?.submit();
    }
  }, [token, url]);

  useEffect(() => {
    acquireAccessToken().then(setToken);
  }, []);

  if (!url || !token) return null;

  let iframeStyles: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    right: 0,
    width: '100%',
    bottom: 0,
    margin: 0,
    border: 'none',
    display: 'block'
  };

  if (styles?.iframe) {
    iframeStyles = {
      ...iframeStyles,
      ...styles.iframe
    };
  }

  return (
    <>
      <form
        ref={formRef}
        id="office_form"
        name="office_form"
        target="office_frame"
        action={url}
        method="post"
      >
        <input name="access_token" value={token?.accessToken} type="hidden" />
        <input name="access_token_ttl" value={0} type="hidden" />
        <input name="user_id" value={token?.account?.localAccountId} type="hidden" />
        <input name="owner_id" value={token?.tenantId} type="hidden" />
      </form>

      <div id="frameholder">
        <iframe
          style={iframeStyles}
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
          name="office_frame"
          id="office_frame"
          allowFullScreen
          title="Office Frame"
        />
      </div>
    </>
  );
}

export default Wopi;
